<template>
  <div style="height: 100%">
    <div style="width: 200px; position: absolute; z-index: 20">
      <Float_menu />
    </div>
    <div ref="Network_all" style="height: 100%"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { Url, grafana_Url, tooltip_basecss } from "../config/env";
import Float_menu from "../views/Float_menu";

export default {
  data() {
    return {
      mychartOptions: {},
      chartWidth: 1720,
      chartHeight: 900,
      symbolSizeTimes: 1,
      envData: {
        colors: {
          status_colors: ["#4301E6", "orange", "#DC251F"],
          border_colors: ["grey", "orange"],
        },
        lineTag: {
          c_1g: { lineColor: "#666", lineWidth: 5, lineType: "dashed" },
          f_1g: { lineColor: "orange", lineWidth: 5, lineType: "dashed" },
          f_10g: { lineColor: "red", lineWidth: 5, lineType: "dashed" },
        },
        nodeSymbolsize: {
          lb: [60, 36],
          lineSample: [60, 36],
          router: [60, 42],
          firewall: [60, 72],
          core_switch: [75, 86],
          server: [60, 42],
          core_switch1: [60, 52],
          core_switch2: [60, 52],
          storage: [60, 52],
          ac: [65, 46],
          switch: [60, 50],
          cloud: [65, 46],
        },
      },
    };
  },
  components: {
    Float_menu,
  },
  methods: {
    // 获取拓扑数据
    async getTopoData(topo_name, env_Data) {
      const status_colors = env_Data.colors.status_colors;
      const border_colors = env_Data.colors.border_colors;

      const [hosts_data, lines_data, borders1_data] = await Promise.all([
        fetch(`${Url}topo_data/${topo_name}/hosts_obj.json`),
        fetch(`${Url}topo_data/${topo_name}/lines_obj.json`),
        fetch(`${Url}topo_data/${topo_name}/borders1_obj.json`),
      ]);

      const hostsData = await hosts_data.json();
      const linesData = await lines_data.json();
      const bordersData1 = await borders1_data.json();

      const hosts = hostsData.data;
      const lines = linesData.data;
      const borders1 = bordersData1.data;

      const charts = {
        hosts: [],
        lines: [],
        lines_1: [],
        borders1: [],
      };

      // 生成节点数据
      for (const key in hosts) {
        let tooltip_info = "";
        const tooltip_list = hosts[key].item_info;
        const problem_obj = hosts[key].problems;

        if (Object.keys(tooltip_list).length !== 0) {
          tooltip_info = tooltip_list
            .map(
              (item) =>
                `<div><span style="color:gray">${Object.keys(
                  item
                )}&nbsp</span>:<span style="color:green">&nbsp${Object.values(
                  item
                )}</span></div>`
            )
            .join("");
        }

        if (Object.keys(problem_obj).length !== 0) {
          tooltip_info += "<div>当前系统存在告警信息如下:</div>";
          let n = 1;
          for (const i in problem_obj) {
            const color = problem_obj[i].priority <= 3 ? "orange" : "red";
            tooltip_info += `<div style="color:${color}">${n}.${problem_obj[i].hostname}:${problem_obj[i].name}</div>`;
            n += 1;
          }
        } else {
          tooltip_info += '<div style="color:green">系统正常</div>';
        }

        const node = {
          name: hosts[key].nodeName,
          value: hosts[key].coords,
          symbolSize: [
            this.envData.nodeSymbolsize[hosts[key].pngPath][0] *
              this.symbolSizeTimes,
            this.envData.nodeSymbolsize[hosts[key].pngPath][1] *
              this.symbolSizeTimes,
          ],
          nodeStatus: hosts[key].nodeStatus,
          symbol: `image://${Url}/topo_data/${topo_name}/${hosts[key].pngPath}_${hosts[key].nodeStatus}.png`,
          tooltip: tooltip_info,
          url1:
            hosts[key].url1[0] === "#"
              ? Url + hosts[key].url1
              : `${grafana_Url[hosts[key].url1]}&var-HOST=${
                  hosts[key].zabbix_hostname
                }`,
          url2:
            hosts[key].url2[0] === "#"
              ? Url + hosts[key].url2
              : hosts[key].url2,
          click_redirect: "true",
        };
        charts.hosts.push(node);
      }

      // 生成连线数据
      for (const key in lines) {
        let tooltip_info = "";
        const tooltip_obj = lines[key].item_info;
        const problem_obj = lines[key].problems;
        let effectShow = 0;

        if (Object.keys(tooltip_obj).length !== 0) {
          tooltip_info = Object.entries(tooltip_obj)
            .map(([k, v]) => `<div style="color:green">${k}:${v}</div>`)
            .join("");

          for (const [k, v] of Object.entries(tooltip_obj)) {
            const [value, unit] = v.split(" ");
            if (
              (parseFloat(value) > parseFloat(lines[key].lineThreshold) &&
                unit === "mb/s") ||
              ["gb/s", "tb/s"].includes(unit)
            ) {
              effectShow = 1;
            }
          }
        }

        if (Object.keys(problem_obj).length !== 0) {
          tooltip_info += "<div>当前系统存在告警信息如下:</div>";
          let n = 1;
          for (const i in problem_obj) {
            const color = problem_obj[i].priority <= 3 ? "orange" : "red";
            tooltip_info += `<div style="color:${color}">${n}.${problem_obj[i]}</div>`;
            n += 1;
          }
        } else {
          tooltip_info += '<div style="color:green">状态正常</div>';
        }

        const line = {
          lineName: lines[key].lineName,
          coords: lines[key].coords,
          lineStatus: lines[key].lineStatus,
          effectShow: effectShow,
          lineStyle: {
            width: lines[key].lineWidth || null,
            opacity: lines[key].lineOpacity || null,
            color: lines[key].lineColor || null,
            type: lines[key].lineType || null,
          },
          tooltip: tooltip_info,
          url1: lines[key].url1
            ? `${grafana_Url[lines[key].url1]}&var-Brand=${lines[key].lineName}`
            : `${grafana_Url.item_url}${lines[key].items}`,
          click_redirect: "true",
        };
        line.effectShow === 1
          ? charts.lines_1.push(line)
          : charts.lines.push(line);
      }

      // 生成边框1数据
      for (const key in borders1) {
        const line = {
          lineName: borders1[key].borderName,
          coords: borders1[key].coords,
          lineStyle: {
            color: borders1[key].borderColor,
            width: 1,
            opacity: 0.3,
          },
          url1: "#/Network_all",
          click_redirect: "true",
        };
        charts.borders1.push(line);
      }

      return charts;
    },

    // 生成图表配置
    makeChartOption(chartData) {
      return {
        backgroundColor: "#111217",
        grid: { left: 0, right: 0, top: 0, bottom: 0 },
        xAxis: { min: 0, max: this.chartWidth, show: false, type: "value" },
        yAxis: {
          min: 0,
          max: this.chartHeight,
          show: false,
          inverse: true,
          type: "value",
        },
        tooltip: tooltip_basecss,
        series: [
          // 节点数据
          {
            type: "graph",
            coordinateSystem: "cartesian2d",
            layout: "none",
            emphasis: { scale: 1.4 },
            label: {
              show: true,
              position: "bottom",
              color: "#666",
              fontFamily: "serif",
              fontWeight: "bold",
              fontSize: 15,
              formatter: (item) => item.data.name,
            },
            data: chartData.hosts,
            zlevel: 3,
          },
          // 无线条效果
          {
            type: "lines",
            polyline: true,
            coordinateSystem: "cartesian2d",
            emphasis: {
              disabled: false,
              lineStyle: { type: "solid", color: "green", zlevel: 2 },
            },
            lineStyle: { color: "grey", show: true, width: 3, type: "dashed" },
            effect: {
              show: false,
              period: 2,
              trailLength: 0.2,
              symbol: "diamond",
              symbolSize: 8,
              color: "white",
            },
            data: chartData.lines,
            zlevel: 2,
          },
          // 有线条效果
          {
            type: "lines",
            polyline: true,
            coordinateSystem: "cartesian2d",
            emphasis: {
              disabled: false,
              lineStyle: { type: "solid", color: "red", zlevel: 2 },
            },
            lineStyle: { color: "grey", show: true, width: 4, type: "dashed" },
            effect: {
              show: true,
              period: 2,
              trailLength: 0.2,
              symbol: "diamond",
              symbolSize: 8,
              color: "white",
            },
            data: chartData.lines_1,
            zlevel: 2,
          },
          // 边框信息
          {
            type: "lines",
            polyline: true,
            coordinateSystem: "cartesian2d",
            tooltip: {
              show: true,
              position: (point) => point[0],
              color: "red",
              formatter: (item) => item.data.lineName,
            },
            lineStyle: { cap: "round", type: "dashed", width: 2 },
            emphasis: {
              disabled: false,
              lineStyle: { cap: "round", type: "solid", width: 4 },
            },
            data: chartData.borders1,
            zlevel: 1,
          },
        ],
      };
    },

    // 创建拓扑图
    async maketopo(topo_name) {
      const myChart = echarts.init(this.$refs[topo_name]);
      const myChartData = await this.getTopoData(topo_name, this.envData);
      this.mychartOptions = this.makeChartOption(myChartData);
      myChart.setOption(this.mychartOptions);

      // 故障节点动画效果
      setInterval(() => {
        const updateNodeStyle = (seriesIndex, rate, zlevel) => {
          if (this.mychartOptions.series[seriesIndex].data.length > 0) {
            for (const i in this.mychartOptions.series[seriesIndex].data) {
              if (
                this.mychartOptions.series[seriesIndex].data[i].nodeStatus != 0
              ) {
                this.mychartOptions.series[seriesIndex].data[i].symbolSize[0] *=
                  rate;
                this.mychartOptions.series[seriesIndex].data[i].symbolSize[1] *=
                  rate;
                this.mychartOptions.series[seriesIndex].data[i].zlevel = zlevel;
              }
            }
          }
        };

        updateNodeStyle(0, 1.25, 4);

        myChart.setOption(this.mychartOptions);

        setTimeout(() => {
          updateNodeStyle(0, 0.8, 4);
          myChart.setOption(this.mychartOptions);
        }, 1000);
      }, 2000);

      // 故障线条动画效果
      setInterval(() => {
        const updateLineStyle = (seriesIndex, color, width, zlevel) => {
          if (this.mychartOptions.series[seriesIndex].data.length > 0) {
            for (const i in this.mychartOptions.series[seriesIndex].data) {
              if (
                this.mychartOptions.series[seriesIndex].data[i].lineStatus != 0
              ) {
                this.mychartOptions.series[seriesIndex].data[
                  i
                ].lineStyle.width = width;
                this.mychartOptions.series[seriesIndex].data[
                  i
                ].lineStyle.color = color;
                this.mychartOptions.series[seriesIndex].data[i].zlevel = zlevel;
              }
            }
          }
        };

        updateLineStyle(1, "red", 6, 4);
        updateLineStyle(2, "red", 6, 4);

        myChart.setOption(this.mychartOptions);

        setTimeout(() => {
          updateLineStyle(1, "grey", 4, 3);
          updateLineStyle(2, "grey", 4, 3);
          myChart.setOption(this.mychartOptions);
        }, 1000);
      }, 2000);

      // 点击事件处理
      let click_type = null;
      myChart.on("click", (data) => {
        if (!click_type) {
          click_type = setTimeout(() => {
            window.location.assign(data.data.url1);
            click_type = null;
          }, 300);
        } else {
          window.open(data.data.url2);
          clearTimeout(click_type);
          click_type = null;
        }
      });

      // 定期更新数据
      setInterval(async () => {
        this.mychartOptions = this.makeChartOption(
          await this.getTopoData("Network_all", this.envData)
        );
        myChart.setOption(this.mychartOptions);
      }, 60000);

      // 窗口调整时重绘图表
      window.onresize = () => {
        myChart.resize();
        this.chartWidth = myChart.getDom().clientWidth;
        this.chartHeight = myChart.getDom().clientHeight;
      };
    },
  },
  mounted() {
    this.maketopo("Network_all");
  },
};
</script>

<style lang="less" scoped>
@import "../style/mixin";
</style>